var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "import-button" }, [
    _c("input", {
      ref: "file",
      attrs: { type: "file", accept: _vm.accept },
      on: { change: _vm.onFileChange },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }